import React from 'react'
import Form from './Form'
import { MapFormProvider } from './FormContext'
import { useCreateMap } from '../../hooks/api/map'

export const CreateMap = () => {
  return (
    <MapFormProvider>
      <Form api={useCreateMap} isCreateMode defaultValues={{ isCompleted: 0 }} />
    </MapFormProvider>
  )
}
